import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import 'react-accessible-accordion/dist/fancy-example.css';

import { getTokenInfo } from './../../../UseToken';
import { reqGET, set_language, content_language} from '../../../Utils';

import { language } from './Language';

import Loader from '../../Loader/Loader';

import {api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');


     // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />
        
            :
            
            <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
                <main>
                    <div className={`dash-cards-2 header`}>
                        {console.log('DADOS ---------->', dados)}
                        <h2 className="dash-title">{language[lang].contests}</h2>
                        <p>{language[lang].home} / {language[lang].contest}</p>
                    </div>

                    <div className={`dash-cards-2 body`}>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 col-sm-8 mb-3">
                                    <h5>{language[lang].name}</h5>
                                    <p>{dados.info.name_01}</p>
                                </div>
                                <div className="col-12 col-sm-4 mb-3">
                                    <h5>{language[lang].contact}</h5>
                                    <p>{dados.info.contact_01}</p>
                                </div>

                                <div className="col-12 col-sm-8 mb-3">
                                    <h5>{language[lang].name}</h5>
                                    <p>{dados.info.name_02}</p>
                                </div>
                                <div className="col-12 col-sm-4 mb-3">
                                    <h5>{language[lang].contact}</h5>
                                    <p>{dados.info.contact_02}</p>
                                </div>

                                <div className="col-12 col-sm-8 mb-3">
                                    <h5>{language[lang].name}</h5>
                                    <p>{dados.info.name_03}</p>
                                </div>
                                <div className="col-12 col-sm-4 mb-3">
                                    <h5>{language[lang].contact}</h5>
                                    <p>{dados.info.contact_03}</p>
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].designation}</h5>
                                <p>{dados.info.designation}</p>
                            </div>

                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_02}</h5>
                                <p>{dados.info.option_02 === 'app_form_option_02_01' ? language[lang].app_form_option_02_01 :  dados.info.option_02 === 'app_form_option_02_02' ? language[lang].app_form_option_02_02 : dados.info.option_02 === 'app_form_option_02_03' ? language[lang].app_form_option_02_03 : dados.info.option_02 === 'app_form_option_02_04' ? language[lang].app_form_option_02_04 : dados.info.option_02 === 'app_form_option_02_05' ? language[lang].app_form_option_02_05 : dados.info.option_02 === 'app_form_option_02_06' ? language[lang].app_form_option_02_06 : dados.info.option_02 === 'app_form_option_02_07' ? language[lang].app_form_option_02_07 : dados.info.option_02 === 'app_form_option_02_08' ? language[lang].app_form_option_02_08 : dados.info.option_02 === 'app_form_option_02_09' ? language[lang].app_form_option_02_09 : dados.info.option_02 === 'app_form_option_02_10' ? language[lang].app_form_option_02_10 : ''}</p>                                
                            </div>

                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_03}</h5>
                                <p>{dados.info.option_03 === 'app_form_option_03_01' ? language[lang].app_form_option_03_01 :  dados.info.option_03 === 'app_form_option_03_02' ? language[lang].app_form_option_03_02 : dados.info.option_03 === 'app_form_option_02_03' ? language[lang].app_form_option_03_03 : dados.info.option_03 === 'app_form_option_03_04' ? language[lang].app_form_option_03_04 : ''}</p>                                
                            </div>
                            
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_04}</h5>
                                <p>{dados.info.description_01}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_05}</h5>
                                <p>{dados.info.description_02}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_06}</h5>
                                <p>{dados.info.description_03}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_07}</h5>
                                <p>{dados.info.description_04}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_08}</h5>
                                <p>{dados.info.description_05}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_09}</h5>
                                <p>{dados.info.description_06}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_10}</h5>
                                <p>{dados.info.description_07}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_11}</h5>
                                <p>{dados.info.description_08}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_12}</h5>
                                <p>{dados.info.description_09}</p>
                            </div>
                            <div className="col-12 mb-3">
                                <h5>{language[lang].app_form_title_13}</h5>
                                <p>{dados.info.description_10}</p>
                            </div>

                            { dados.info.files.length > 0 ? (
                                <div className="col-12 mb-3">
                                        <h5>{language[lang].files}</h5>
                                        {
                                        dados.info.files.map((value, key) => {
                                            return (
                                                <div key={key}>
                                                    <p>
                                                        {console.log('VALUE', value)}
                                                        <a href={value.link} download={value.name} target="_blank" rel="noreferrer">{value.name}</a>
                                                    </p>
                                                </div>
                                            )
                                        })
                                        }
                                </div> 
							) : null }
                        </div>
                    </div>

                    <div className={'dash-cards-2 footer'}>
                        <nav className="navbar bottom-navbar navbar-light">
                            <div className="navbar-footer">
                                <ul className="navbar-nav float-left"></ul>
                                <ul className="navbar-nav float-right">
                                    <li className="nav-item">
                                        <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                            <img alt='' src={'./img/seta_2.svg'} />
                                            <span>{language[lang].back}</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </main>
            </div>
}